import { dataUserLabel } from 'dls-icons-data'
import { createIcon } from '../common'

const IconUserLabel = /*#__PURE__*/createIcon(dataUserLabel)
export default IconUserLabel
